// Baltic Route options for LPG VLGC PMT rates
export const balticRoutes = [
    {
        id: 1,
        value: 'Rt/Ch',
        label: 'Rt/Ch',
    },
    {
        id: 2,
        value: 'H/Fl',
        label: 'H/Fl',
    },
    {
        id: 3,
        value: 'H/Ch',
        label: 'H/Ch',
    },
];

export const infos = [
    {
        id: 1,
        value: '(via Pan)',
        label: '(via Pan)',
    },
    {
        id: 2,
        value: '(via Cape)',
        label: '(via Cape)',
    },
    {
        id: 3,
        value: '(Suez)',
        label: '(Suez)',
    },
];

export const getBalticRouteByValue = (value) => {
    return balticRoutes.find((route) => route.value === value);
};

export const getInfoByValue = (value) => {
    return infos.find((option) => option.value === value);
};
